module.exports = __webpack_public_path__ + "static/media/2007 Luxembourg.32dfedf7.jpg";